<ng-container *transloco="let t">
    <section>
        <header>
            <h3>
                {{ t("auth.account-stepper.step") | uppercase }}
                {{ selectedIndex + 1 }}
                {{ t("auth.account-stepper.of") | uppercase }}
                {{ steps.length }}
            </h3>
        </header>

        <div [ngTemplateOutlet]="selected ? selected.content : null"></div>
    </section>
</ng-container>
